require('./products-edit-container.scss')

module.exports = {
  template: require('./products-edit-container.pug')()
  controller: require('./products-edit-container.ctrl')
}
